/**
 * Restaura progreso de una encuesta a partir de las preguntas y respuestas guardadas.
 *
 * @returns {{ answers: Array<number|null>, questionIndex: number, hasProgress: boolean, isComplete: boolean }}
 */
export function resolveSurveyResume(list, savedList, totalSlots = 40) {
  const answers = Array(totalSlots).fill(null);
  const saved = Array.isArray(savedList) ? savedList : [];

  if (!Array.isArray(list) || list.length === 0) {
    return {
      answers,
      questionIndex: 0,
      hasProgress: false,
      isComplete: false,
    };
  }

  const savedIds = new Set(
    saved
      .map((r) => Number(r.id_pregunta))
      .filter((id) => Number.isInteger(id))
  );

  saved.forEach((r) => {
    const idx = list.findIndex((p) => Number(p.id_pregunta) === Number(r.id_pregunta));
    if (idx >= 0) answers[idx] = r.valor;
  });

  const firstUnanswered = list.findIndex((p) => !savedIds.has(Number(p.id_pregunta)));
  const isComplete = firstUnanswered === -1 && savedIds.size > 0;

  return {
    answers,
    questionIndex: isComplete ? list.length - 1 : Math.max(firstUnanswered, 0),
    hasProgress: savedIds.size > 0,
    isComplete,
  };
}
